import { useState } from 'react';

import { useToastStore } from '@pkg/components/Toast/useToastStore';

import { setUser } from '@app/store/actions/user';
import { useProfileDetailsUpdate } from '@app/store/zustand';

import { useAppDispatch } from '../redux/useAppDispatch.ts';
import { useAppSelector } from '../redux/useAppSelector.ts';

const ERROR_KEY_USERNAME_DUPLICATE = 'index_users_username';

export function useHandleProfileData() {
    const [matchingUsername, setMatchingUsername] = useState<string>();

    const dispatch = useAppDispatch();
    const { addToast } = useToastStore();

    const legacyUser = useAppSelector((state) => state.user?.userAccount);
    const primaryYat = useAppSelector((state) => state.user?.primaryYat);

    const { mutateAsync } = useProfileDetailsUpdate();

    function updateUsername(username: string) {
        mutateAsync({
            primaryYat: primaryYat ?? '',
            newUsernameOpt: username,
        }).then((result) => {
            const errors = result.errors;
            const duplicateNameError = errors?.some((error) => error.message.includes(ERROR_KEY_USERNAME_DUPLICATE));

            if (duplicateNameError) {
                setMatchingUsername(username);
                return;
            }

            const success = Boolean(result.data?.profilesUpdate) && !errors?.length;

            if (success) {
                addToast({
                    emoji: '💎',
                    message: 'Username updated!',
                });
            }

            // TODO: Find out if we actually still need this
            // call to `setUser()`.
            if (success && legacyUser && primaryYat) {
                dispatch(
                    setUser({
                        ...legacyUser,
                        user: {
                            ...legacyUser?.user,
                            username,
                            eid: primaryYat,
                        },
                    }),
                );
            }
        });
    }

    function updateBio(description: string) {
        mutateAsync({
            primaryYat: primaryYat ?? '',
            newDescriptionOpt: description,
        }).then((result) => {
            const errors = result.errors;

            // TODO: What specific errors do we need to handle?
            if (errors?.length) return;

            const success = Boolean(result.data?.profilesUpdate) && !errors?.length;

            if (success) {
                addToast({
                    emoji: '💎',
                    message: 'Bio updated!',
                });
            }
        });
    }

    return {
        matchingUsername,
        updateUsername,
        updateBio,
    };
}
